var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relatived"},[_c('div',{staticClass:"card-positions containers"},[_c('FormCard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }